import { Reveal } from "../components/Reveal";
import { IMG } from "../lib/assets";
import { Link } from "react-router-dom";

export default function About() {
  const values = [
    ["Confidence", "We make apparel that helps women stand taller and move bolder."],
    ["Community", "Women supporting women — in the studio, online, and everywhere in between."],
    ["Quality", "Premium, responsibly sourced fabrics engineered to last for years, not seasons."],
    ["Performance", "Tested by athletes, worn by everyone. Function you can feel."],
  ];
  return (
    <div data-testid="about-page">
      <section className="relative h-[70vh] min-h-[520px] overflow-hidden">
        <img src={IMG.community} alt="SV story" className="absolute inset-0 h-full w-full object-cover object-top" />
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative container-luxe h-full flex flex-col justify-end pb-16 text-bone">
          <p className="overline text-bone/80 mb-4">Our Story</p>
          <h1 className="h-display text-5xl sm:text-7xl max-w-3xl">Built On Confidence, Worn With Strength.</h1>
        </div>
      </section>

      <section className="container-luxe py-24 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-testid="about-brand-story">
        <Reveal><div className="aspect-[4/5] overflow-hidden bg-[#EDE6DA]"><img src={IMG.hero} alt="Woman in SV Athletic Wear charcoal set in a pilates studio" className="h-full w-full object-cover object-[70%_center]" data-testid="about-charcoal-image" /></div></Reveal>
        <Reveal delay={0.1}>
          <div className="lg:pl-4">
            <p className="font-serif text-2xl sm:text-3xl font-light leading-relaxed">
              SV Athletic Wear exists to empower women through premium apparel that combines confidence, performance, comfort, and style — whether you're working out, traveling, or simply moving through your day.
            </p>
            <p className="mt-8 text-sm text-muted-foreground font-light leading-relaxed">
              We started with a single belief: that what you wear should make you feel strong, beautiful, and capable. Every fabric is chosen for how it performs and how it feels. Every silhouette is fit-tested on real women, from 18 to 65, because confidence has no size and no age.
            </p>
            <p className="mt-6 text-sm text-muted-foreground font-light leading-relaxed">
              Today, SV is a community of women who show up for themselves and each other. This is more than activewear. It's a reminder — worn on the body — that you are capable of extraordinary things.
            </p>
          </div>
        </Reveal>
      </section>

      {[["Movement", IMG.charcoalMatcha, "Designed to disappear against the skin so nothing stands between you and your practice."],
        ["Strength", IMG.blackSelfie, "Compression that supports and sculpts, engineered from four-way stretch performance knits."],
        ["Comfort", IMG.lavenderPuppy, "Buttery-soft, tagless, and breathable — the pieces you reach for every single day."]].map(([title, img, copy], i) => (
        <section key={title} className={`container-luxe py-16 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
          <Reveal className="[direction:ltr]"><div className="aspect-[4/5] overflow-hidden bg-beige/40"><img src={img} alt={title} className="h-full w-full object-cover" /></div></Reveal>
          <Reveal delay={0.1} className="[direction:ltr]">
            <p className="overline text-gold mb-4">{`0${i + 1}`}</p>
            <h2 className="h-display text-4xl sm:text-5xl mb-6">{title}</h2>
            <p className="text-sm text-muted-foreground font-light leading-relaxed max-w-md">{copy}</p>
          </Reveal>
        </section>
      ))}

      <section className="bg-beige/40 py-24">
        <div className="container-luxe">
          <Reveal><h2 className="h-display text-4xl sm:text-5xl mb-14 text-center">What We Stand For</h2></Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map(([t, d], i) => (
              <Reveal key={t} delay={i * 0.08}>
                <div className="border-t border-charcoal/20 pt-6">
                  <h3 className="font-serif text-2xl mb-3">{t}</h3>
                  <p className="text-sm text-muted-foreground font-light leading-relaxed">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="container-luxe py-24 text-center">
        <Reveal>
          <h2 className="h-display text-4xl sm:text-6xl mb-8">Move With Us.</h2>
          <Link to="/shop" className="btn-primary" data-testid="about-shop-btn">Shop The Collection</Link>
        </Reveal>
      </section>
    </div>
  );
}
